import React, { useEffect, useState } from "react";
import "./style.scss";
import AllItemsDialog from "../../../Component/ContentDialog/ContentDialog";
import { scrollTop } from "Utils/ScrollTop";
import { Link, useLocation } from "react-router-dom";
import { PopupProps } from "../types/type";
import CommonService from "Component/Modules/API/Services/Common.service";
import Skeleton from "Component/Skeleton/Skeleton";
import useDidMountEffect from "Component/UseDisMountEffect/Function";
import withWorks from "../HOC/withWorks";

function GraphicDesign() {
  const [workList, setWorkList] = useState<PopupProps[]>([]);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    CommonService.GetWorkAll([1])
      .then((response:any) => {
        if (response) {
          const data = response.filter((item :any)=> item.sub_category ==='Graphic Design')
          setWorkList(data);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);
  function SkeletonContentsList(size: number) {
    var list = [];
    for (var i = 0; i < size; i++) {
      list.push(
        <div key={i} className="img">
         <Skeleton variant="rounded" height={195} />
        </div>
      );
    }
    return list;
  }
  useDidMountEffect(() => {
    setLoading(false);
  }, [workList]);
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  return (
    <>
      {workList.map((item, index) => (
        <React.Fragment key={index}>
          {location.hash === "#" + item.id && (
            <>
              <AllItemsDialog data={item} />
              <p className="titleCategory">Graphic Design</p>
            </>
          )}
        </React.Fragment>
      ))}
      <div className="graphic" style={{ width: "100%", height: "100%" }}>
        {loading === false
          ? workList.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  to={{ search: "graphicdesign", hash: String(item.id) }}
                  onClick={() => scrollTop()}
                >
                  <div className="works-item">
                    <img src={item.sub_thumbnail} alt="" />
                    <div className="card-info">
                      <div className="card-title">
                        <span style={{ textTransform: "uppercase" }}>
                          Graphic Design
                        </span>
                      </div>
                      <div
                        className="card-content"
                        style={{ textAlign: "center" }}
                      >
                        <p>{item.name.en}</p>
                        <p>{item.year}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            ))
          : SkeletonContentsList(15)}
      </div>
    </>
  );
}

export default withWorks(GraphicDesign);
